import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';
import Container from '../../container';
import SubHead from '../../subhead';
import Grid from '../../grid';
import RatioImg from '../../ratio-img';

const imageStyles = `
  box-shadow: 9px 22px 40px 9px rgba(0, 0, 0, .18);
`;

const sharedImgStyles = `
  position: absolute;
  width: 340px;
  box-shadow: 9px 22px 40px 9px rgba(0, 0, 0, .18);

  ${screen.below(bp.desktop, `
    width: 260px;
  `)}

  ${screen.below(bp.laptop, `
    width: 200px;
  `)}

  ${screen.below(bp.mobileSm, `
    width: 160px;
  `)}
`;

const topImgStyle = `
  ${sharedImgStyles}
  top: 100%;
  right: -20px;
  transform: rotate(-17deg);

  ${screen.below(bp.laptop, `
    top: calc(100% + 80px);
  `)}

  ${screen.below(bp.tablet, `
    top: 50%;
  `)}

  ${screen.below(bp.portrait, `
    left: 10%;
    z-index: 0;
    transform: rotate(-17deg);
  `)}

  ${screen.below(bp.mobileSm, `
    top: 60%;
    left: 0;
    transform-origin: bottom left;
  `)}
`;

const botImgStyle = `
  ${sharedImgStyles}
  position: absolute;
  top: calc(100% + 150px);
  right: -180px;
  transform: rotate(10deg);

  ${screen.below(bp.desktop, `
    top: calc(100% + 110px);
    right: -120px;
  `)}

  ${screen.below(bp.laptop, `
    top: calc(100% + 180px);
    right: -90px;
  `)}

  ${screen.below(bp.tablet, `
    top: calc(50% + 100px);
  `)}

  ${screen.below(bp.portrait, `
    right: 10%;
    top: 70%;
    transform: rotate(18deg);
  `)}

  ${screen.below(bp.mobileSm, `
    top: 100%;
    right: 0;
    transform-origin: bottom right;
  `)}
`;

const groupedImageStyles = [topImgStyle, botImgStyle];

const CreateHero = ({ edit, subheading, title, images }) => {
  const [image1, ...restImages] = images;
  const imgParams = '?w=340&h=230&q=80&fit=thumb&fm=jpg&fl=progressive';

  return (
    <Hero>
      <Container>
        <Grid position="static">

          {!edit &&
            <HeroGridItem span={4}>
              {images && image1 && image1.fields &&
                <HeroImage>
                  <RatioImg
                    src={`${image1.fields.file.url}${imgParams}`}
                    width={340}
                    height={230}
                    alt=""
                    styles={imageStyles}
                  />
                </HeroImage>
              }

              {restImages && restImages.map((image, i) => {
                if (!image.fields) return null;

                return (
                  <RatioImg
                    key={image.sys.id}
                    src={`${image.fields.file.url}${imgParams}`}
                    width={340}
                    height={230}
                    alt={image.fields.description}
                    styles={groupedImageStyles[i]}
                  />
                );
              })}
            </HeroGridItem>
          }

          <HeroGridItem span={edit ? 12 : 6}>
            <SubHead align={edit ? 'center' : 'left'}>{subheading}</SubHead>
            <h1 align={edit ? 'center' : 'left'}>{title}</h1>
          </HeroGridItem>

        </Grid>
      </Container>
    </Hero>
  );
};

const Hero = styled.section`
  position: relative;
  padding: 240px 0 40px;

  ${screen.below(bp.desktop, `
    padding-top: 200px;
  `)}

  ${screen.below(bp.laptop, `
    padding-top: 180px;
  `)}

  ${screen.below(bp.portrait, `
    padding-top: 120px;
  `)}

  ${screen.below(bp.mobileSm, `
    padding-top: 80px;
  `)}
`;

const HeroGridItem = styled(Grid.Item)`
  ${screen.below(bp.portrait, `
    position: relative;
    grid-column: 2 / span 10 ;
    text-align: center;

    ${SubHead} {
      text-align: center;
    }

    &:first-of-type {
      grid-row: 2;
    }
  `)}
`;

const HeroImage = styled.div`
  position: relative;
  width: 80%;
  max-width: 340px;
  margin-top: 40px;
  transform: rotate(9deg);
  z-index: 2;

  ${screen.below(bp.portrait, `
    margin: -10px auto 0;
    width: 200px;
    margin-bottom: 40px;
  `)}

  ${screen.below(bp.mobileSm, `
    width: 160px;
    margin-bottom: 0;
  `)}
`;

CreateHero.propTypes = {
  subheading: PropTypes.string,
  title: PropTypes.string,
  images: PropTypes.array,
};

CreateHero.defaultProps = {
  images: [],
};

export default CreateHero;
